const nativeCreativeAssetsRules = {
    title: [(title): boolean | string => (title && Boolean(title.trim())) || 'Title is required.'],
};

export default nativeCreativeAssetsRules;
